import { colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';
import palette from './palette';
import { createTheme } from '@material-ui/core/styles';


const theme = createTheme({
  palette,
  shadows,
  typography,
  overrides: {
    MuiTableSortLabel: {
      root: {
        '&$active': {
          '&& $icon': {
            color: 'cyan'
          },
        },
      },
    },
    MuiTableCell: {
      head: {
        fontSize: '0.9em',
        backgroundColor: "#1b1918FF !important",
        color: colors.common.white,
        height: "50px"
      },
      footer: {
        borderTop: '2px solid #1b1918FF',
        fontSize: '1.0em',
        height: "45px"
      }
    },
    MuiTableRow: {
      hover: {
        "&$hover:hover": {
          backgroundColor: colors.blue[50]
        }
      }
    }
  }
});

export default theme;
